function game_1002()
{

}
game_1002.read_odd = function(id)
{
  if(id === 1)
  {
    return "9";
  }
  else if(id === 2)
  {
    return "10";
  }
  else if(id === 3)  {
    return "4";
  }
  else if(id === 4)  {
    return "7";
  }
  else if(id === 5){
    return "6";
  }
  else if(id === 6){
    return "15";
  }
  else if(id === 7){
    return "12";
  }
  else if(id === 8){
    return "5";
  }
  else if(id === 9){
    return "8";
  }
  else if(id === 10){
    return "10";
  }
  else if(id === 11){
    return "2";
  }
  else if(id === 12){
    return "2";
  }
  else if(id === 13){
    return "3";
  }
  else if(id === 14){
    return "20";
  }
  else if(id === 15){
    return "9";
  }
  else if(id === 16){
    return "10";
  }
  else if(id === 17){
    return "4";
  }
  else if(id === 18){
    return "7";
  }
  else if(id === 19){
    return "6";
  }
  else if(id === 20){
    return "10";
  }
  else if(id === 22){
    return "5";
  }
  else if(id === 23){
    return "8";
  }
  else if(id === 24){
    return "2";
  }
  else if(id === 25){
    return "2";
  }
  else if(id === 26)
  {
    return "3";
  }
  else if(id === 50){
    return  "40";
  }
  else if(id === 51){
    return  "300-600";
  }
  else if(id === 52){
    return  "150-200";
  }
  else if(id === 53){
    return  "25";
  }
 else if(id === 54){
   return  "30";
  }
  else if(id === 55){
    return  "18";
  }
 else if(id === 100){
    return  "10";
 }
  return  "";
}
export {
  game_1002
};



// WEBPACK FOOTER //
// ./src/components/fish/game_1002.js